import { Outlet } from 'react-router-dom'
import { PageHeader } from '@/components/shell/PageHeader'
import { Tabs } from '@/components/ui'
import { useDocumentTitle } from '@/lib/hooks'

/** /audit/changes and /audit/logins. Each tab keeps its own filters in the URL. */
export default function AuditLayout() {
  useDocumentTitle('Audit')
  return (
    <div className="grid grid-cols-1 gap-5">
      <PageHeader title="Audit" description="Every change and every sign-in, across all tenants. Dates are whole days in your time zone, and both ends are included." />
      <Tabs
        label="Audit sections"
        items={[
          { to: 'changes', label: 'Changes' },
          { to: 'logins', label: 'Logins' },
        ]}
      />
      <Outlet />
    </div>
  )
}
